<template>
  <BasePageContainer>
    <SettingHeader>
      テンプレート編集
    </SettingHeader>
    <div
      v-if="initialized"
      class="pt-10 pb-4">
      <div class="d-flex justify-content-end">
        <MiniButton :to="`/admin/mandala_goal_templates/add?copyWith=${mandalaGoalTemplateId}`">
          コピー
        </MiniButton>
      </div>
      <MandalaGoalTemplateForm
        is-edit
        :mandala-goal-template="mandalaGoalTemplate"
        :response-errors="responseErrors"
        @submit="submit" />
    </div>
  </BasePageContainer>
</template>

<script>
import SettingHeader from '@/components/parts/SettingHeader.vue'
import MandalaGoalTemplateForm from '@/components/view/mandala_goal_templates/MandalaGoalTemplateForm.vue'
import MiniButton from '@/components/parts/MiniButton.vue'

export default {
  components: {
    SettingHeader,
    MiniButton,
    MandalaGoalTemplateForm
  },
  data() {
    return {
      mandalaGoalTemplate: null,
      responseErrors: {}
    }
  },
  computed: {
    initialized() {
      return this.mandalaGoalTemplate !== null
    },
    mandalaGoalTemplateId() {
      return this.$route.params.id
    }
  },
  async created() {
    this.$store.commit('startLoading')
    await this.fetchMandalaGoalTemplate()
    this.$store.commit('finishLoading')
  },
  methods: {
    fetchMandalaGoalTemplate() {
      return this.$axios.get(`/mandala_goal_templates/${this.mandalaGoalTemplateId}/`).then(res => {
        this.mandalaGoalTemplate = res.data
      })
    },
    async submit(body) {
      this.$store.commit('startLoading')

      await this.$axios.patch(`/mandala_goal_templates/${this.mandalaGoalTemplateId}/`, body).then((res) => {
        const updatedMandalaGoalTemplate = res.data
        this.$store.commit('notify/set', {message: `${updatedMandalaGoalTemplate.name}を更新しました`})
        this.$router.push('/admin/mandala_goal_templates/')
      }).catch((e) => {
        console.error(e)
        this.responseErrors = e.response.data
        this.$store.commit('notify/set', {isUnknownError: true, type: 'danger'})
      })

      this.$store.commit('finishLoading')
    }
  }
}
</script>

<style>

</style>